    export enum SuccessLevelEnum {
        Success = 0,
        Warning = 1,
        Fatal = 2,
    }

    export enum EnumSecurityObject {
        Permit = 1,
        WaitList = 2,
        Person = 3,
        Vessel = 4,
        Berth = 5,
        Inspection = 6,
        Attachment = 7,
        Payment = 8,
        Communication = 9,
        Action = 10,
        Vehicle = 11,
        User = 12,
        Role = 13,
        Configuration = 14,
    }

    export enum EnumSecurityAction {
        View = 1,
        Add = 2,
        Edit = 3,
        Delete = 4,
    }

    export enum EnumSecurityLevel {
        None = 0,
        Mine = 1,
        Filtered = 2,
        All = 3,
    }

    export enum SearchType {
        ByBerthNumber = 1,
        ByBoatRegistration = 2,
        ByBoatName = 3,
        ByLastName = 4,
        Nearby = 5,
        All = 6,
        RegDoc = 7,
        ByStickerNumber = 8
    }

    export enum EnumTimePeriods {
        "Past 24 Hours" = 1,
        "Past 7 Days" = 2,
        "Past 30 Days" = 3,
        All = 4,
        Other = 5
    }

    export enum EnumPersons {
        Me = 1,
        All = 2
    }

    export enum ActivityTypes {
        All = 0,
        Note = 1,
        "Time Log" = 2,
        Incident = 3,
        Equipment = 4,
        Pumpout = 5,
        Violation = 6,
        Condition = 7,
        Safety = 8,
        GAR = 9
    }

    export enum ActivityColors {
        danger = 1,
        secondary = 2,
        success = 3,
        warning = 4,
        primary = 5,
        tertiary = 6,
        dark = 7,
        medium = 8,
        
    }